import { render, staticRenderFns } from "./LeftSideBarItemSquare.vue?vue&type=template&id=3635768a&scoped=true&"
import script from "./LeftSideBarItemSquare.vue?vue&type=script&lang=js&"
export * from "./LeftSideBarItemSquare.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideBarItemSquare.vue?vue&type=style&index=0&id=3635768a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635768a",
  null
  
)

export default component.exports